import React from "react";
import { Card, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Logo from "components/common/Logo";
import Flex from "components/common/Flex";
import paths from "routes/paths";

const AppCard = ({ to, logoName, text }) => {
  return (
    <Col
      xs={12}
      sm={6}
      md={4}
      as={Flex}
      className="justify-content-center align-items-center"
    >
      <Card
        as={Link}
        to={to}
        style={{
          width: "100%",
          maxWidth: "25rem",
          height: "16rem",
          textDecoration: "none",
          cursor: "pointer",
          borderRadius: "0.5rem",
          transition: "transform 0.2s ease, box-shadow 0.2s ease",
        }}
        className="clickable-card"
      >
        <Card.Body
          style={{
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
          className="hide-scrollbar"
        >
          <Logo name={logoName} />
          <Card.Text
            style={{
              wordWrap: "break-word",
              overflowWrap: "break-word",
              flex: 1,
              textAlign: "center",
            }}
          >
            {text}
          </Card.Text>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default AppCard;
